<template>
    <div class="chart-wrapper">
        <apexchart :key="internalKey" type="donut" height="270" :options="computedOptions" :series="series" />
        <div class="chart-caption" v-if="caption">
            <img v-if="icon === 'people'" class="caption-icon" src="@/assets/img/chart1.webp" alt="trending icon" />
            <img v-else class="caption-icon" src="@/assets/img/chart2.png" alt="users icon" />
            <span>{{ caption }}</span>
        </div>
    </div>

</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {
    name: 'ChartDonut',
    components: { apexchart: VueApexCharts },
    props: {
        series: { type: Array, required: true },
        labels: { type: Array, required: true },
        colors: { type: Array, default: () => [] },
        caption: { type: String, default: '' },
        icon: { type: String, default: 'people' }
    },
    data() {
        return { internalKey: 0 };
    },
    computed: {
        computedOptions() {
            return {
                chart: {
                    toolbar: { show: false }, type: 'donut',
                    height: 270
                },
                labels: this.labels,
                legend: {
                    position: 'right',
                    floating: true,
                },
                colors: this.colors,
                dataLabels: { enabled: true, formatter: (val) => val.toFixed(1) + '%', style: { fontWeight: '600' } },
                stroke: { width: 2, colors: ['#fff'] },
                plotOptions: { pie: { donut: { size: '48%' }, offsetX: -50 } },
                animations: { enabled: true, speed: 600 },
            };
        }
    },
    watch: {
        series() { this.internalKey += 1; },
        labels() { this.internalKey += 1; }
    }
}
</script>

<style lang="scss" scoped>
.chart-wrapper {
    width: 100%;
    position: relative;
    padding-bottom: 28px;
}

.chart-caption {
    position: absolute;
    bottom: 0;
    left: calc(50% - 50px);
    transform: translateX(-50%);

    display: flex;
    align-items: center;
    gap: 8px;

    font-weight: 500;
    font-size: 14px;
    color: #374151;
}

.caption-icon {
    width: 20px;
}
</style>
